export const generateCustomizedSyncBody = (store) => ({
  groups: store.getState().customizedautosync.self.syncAll
    ? []
    : store.getState().customizedautosync.self.interactedGroups,
  excludeMode: store.getState().customizedautosync.self.syncAll
    ? false
    : store.getState().customizedautosync.self.excludeMode,
  integrationType: store.getState().customizedautosync.self.integrationType,
  syncShared: store.getState().customizedautosync.self.includeSharedMailboxes,
})
